import React, { useEffect, useState } from 'react'
import { modifiedColumns } from './Column'
import { terminalView } from '@fareye/configs'
import { Flex, styled, Table } from '@fareye/ui'
const DynamicPaginationContainer: any = styled(Flex)`
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
  background: ${props =>
    props.title == 'ARRIVALS'
      ? terminalView.darkTheme.arrival.paginationHeader
      : terminalView.darkTheme.departure.paginationHeader};
  @media (min-width: 3840px) {
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 44px;
    font-weight: 600;
  }
`

function getColor(id: any, tableName: any) {
  const tableTypeColor =
    tableName == 'ARRIVALS'
      ? terminalView.darkTheme.arrival
      : terminalView.darkTheme.departure
  const color = id % 2 == 0 ? tableTypeColor.row1 : tableTypeColor.row2
  return color
}

export const TerminalViewTable = (props: any) => {
  let timer: any
  const [pageIndex, setPageIndex] = useState(0)
  let totalPages = props.pageSize
    ? Math.ceil(props.fetchedDataFromApi?.length / props.pageSize)
    : 0
  useEffect(() => {
    let x = pageIndex
    timer = setInterval(() => {
      x = totalPages ? (x + 1) % totalPages : 0
      setPageIndex(x)
    }, props.pageChangeTimeInterval)
    return () => clearInterval(timer)
  })
  const tableColorType =
    props.tableName == 'ARRIVALS'
      ? terminalView.darkTheme.arrival
      : terminalView.darkTheme.departure
  const tableProps = {
    data: props.fetchedDataFromApi,
    columns: modifiedColumns(props.tableName, props.columns),
    totalElements: props.fetchedDataFromApi?.length,
    defaultPageSize: props.pageSize,
    dataLoading: props.dataLoading,
    pageChangeTimeInterval: props.pageChangeTimeInterval,
    style: {
      th: {
        background: tableColorType.header,
        color: tableColorType.headerText,
        borderRight: '0px',
        padding: '0px'
      },
      table: {
        border: '0px'
      }
    },
    getTrProps: (row: any) => {
      return {
        style: {
          backgroundColor: getColor(row.id, props.tableName)
        }
      }
    },
    getTdProps: (row: any) => {
      return {
        style: {
          padding: '0px',
          borderRight: '0px'
        }
      }
    }
  }

  const paginationContainer = ({ children }: any) => {
    return (
      <DynamicPaginationContainer alignItemsCenter title={props.tableName}>
        <div
          style={{
            marginLeft: '10px',
            marginRight: 'auto',
            padding: '5px 0px',
            color: terminalView.darkTheme.arrival.paginationText
          }}
        >
          {props.tableName}
        </div>
        {children}
      </DynamicPaginationContainer>
    )
  }

  return (
    <Table
      {...tableProps}
      data={props.fetchedDataFromApi}
      defaultPageSize={props.pageSize}
      showTotalCount={false}
      showTerminalView={true}
      paginationWrapper={paginationContainer}
      defaultPageIndex={pageIndex}
    />
  )
}
